import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import Form from './Form';
import { ApiService } from '../../../services';

import './Edit.scss';

export interface FormaPagoRequest {
  matriculate: {
    id: string | undefined;
    nombre: string;
    apellido: string;
    delegacion: string;
  };

  forma_pago: string;
  tipo_tarjeta: string;
  numero_tarjeta_cbu: string;

  motivo_rechazo: string;

  state_id: string;
}

function View() {
  const { id } = useParams();

  const [data, setData] = useState<FormaPagoRequest>({
    matriculate: {
      id: id,
      nombre: '',
      apellido: '',
      delegacion: '',
    },

    forma_pago: '',
    tipo_tarjeta: '',
    numero_tarjeta_cbu: '',

    motivo_rechazo: '',

    state_id: '',
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    ApiService.getOne('matriculates/forma-pago-request', id)
      .then(({ payload }) => {
        setData(payload);
      })
      .finally(() => setIsLoading(false));
  }, [id]);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body"></div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Card className="bg-secondary shadow">
          <CardHeader>
            <Row>
              <Col md="8">
                <h3 className="mb-0">Solicitud de Modificación de Forma de Pago #{ id }</h3>
              </Col>
              <Col md="4" className="text-right">
                <Link to='/admin/matriculates/requests'>
                  <Button color="primary" size="md">Volver</Button>
                </Link>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form
              data={ data }
              setData={ setData }
              isLoading={ isLoading }
              onAccept={ false }
              onReject={ false }
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default View;
